var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _rect3, _path5, _path6, _path7, _rect4, _line, _line2, _line3, _line4, _line5, _path8, _rect5, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetagrab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2950",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 92.53 108.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-14,.cls-2,.cls-3,.cls-4{stroke:#312c23;}.cls-1,.cls-2{stroke-width:2px;}.cls-1{fill:url(#linear-gradient);}.cls-2{fill:#ad9a6f;}.cls-11,.cls-3,.cls-9{fill:#fff;}.cls-3{stroke-width:1.58px;}.cls-4,.cls-7{stroke-width:1.56px;}.cls-4{fill:url(#linear-gradient-2);}.cls-15,.cls-5{fill:none;stroke:#201c13;}.cls-5{stroke-width:2.05px;}.cls-12,.cls-13,.cls-6,.cls-7{fill:#191414;stroke:#191414;}.cls-6{stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}.cls-8{fill:#34a5da;}.cls-10{fill:url(#linear-gradient-3);}.cls-11{stroke:#000;}.cls-11,.cls-14{stroke-width:1.74px;}.cls-12{stroke-linejoin:bevel;stroke-width:0.53px;}.cls-13{stroke-miterlimit:10;}.cls-14{fill:url(#radial-gradient);}.cls-15{stroke-width:2.47px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 565.8,
    y1: -262.68,
    x2: 565.8,
    y2: -294.5,
    gradientTransform: "matrix(1, 0, 0, -1, -510.29, -256.36)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cab78d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cab78d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 589.61,
    y1: -305.59,
    x2: 409.77,
    y2: -233.19,
    gradientTransform: "matrix(1, 0, 0, -1, -518.54, -261.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a39066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a39066",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 28.71,
    y1: 70.13,
    x2: 75.46,
    y2: 58.63,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 132)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c9d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8c9d2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 565.39,
    cy: -350.62,
    r: 30.77,
    gradientTransform: "matrix(1, 0, 0, -1, -518.54, -261.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad9a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#ad9a6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#ad9a6f"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "metagrab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.25,99V17L22.35,5.88H88.48l11.3,11.3V99.76H11.25Z",
    transform: "translate(-8.25 -4.88)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.23,99.49v-82l88.53.19v82.58H11.23Z",
    transform: "translate(-8.25 -4.88)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect3649",
    className: "cls-3",
    x: 11.71,
    y: 16.94,
    width: 70.42,
    height: 34.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "rect3005",
    className: "cls-4",
    x: 11.7,
    y: 17.9,
    width: 70.44,
    height: 33.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.67,40.19h24",
    transform: "translate(-8.25 -4.88)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path4291",
    className: "cls-6",
    d: "M26.85,48.62V45.89H11.25V34.47h15.6V29l7.85,5.55c4.32,3.06,7.86,5.58,7.87,5.6s-3.45,2.5-7.7,5.5L27,51.24l-.15.11V48.62Z",
    transform: "translate(-8.25 -4.88)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "rect3007",
    className: "cls-7",
    x: 11.7,
    y: 55.9,
    width: 70.44,
    height: 33.44
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M20.67,77.5,39.8,44.36,86.85,71.52,76.22,89.94Z",
    transform: "translate(-8.25 -4.88)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M25.29,77.75,33.7,46.38,85,68.63,80.6,85.19Z",
    transform: "translate(-8.25 -4.88)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M25.29,77.75,33.7,46.38,85,68.63,80.6,85.18Z",
    transform: "translate(-8.25 -4.88)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "rect3025",
    className: "cls-11",
    x: 7.54,
    y: 70.72,
    width: 78.62,
    height: 37.33
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 28.53,
    y1: 45.43,
    x2: 75.39,
    y2: 65.01
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 26.56,
    y1: 50.16,
    x2: 73.42,
    y2: 69.74
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 24.58,
    y1: 54.89,
    x2: 71.44,
    y2: 74.47
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 22.61,
    y1: 59.62,
    x2: 69.47,
    y2: 79.19
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 20.63,
    y1: 64.35,
    x2: 67.49,
    y2: 83.92
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M49.08,59a1.11,1.11,0,0,1,.58-1.39,1,1,0,0,1,1.34.56A1,1,0,0,1,51,59a1.08,1.08,0,0,1-.57.58A1,1,0,0,1,49.08,59m-2,4.78a1,1,0,0,1,0-.8,1,1,0,0,1,.56-.58A1,1,0,0,1,49,63a1,1,0,0,1,0,.81,1.06,1.06,0,0,1-.57.57.91.91,0,0,1-.79,0,1,1,0,0,1-.55-.56M44.17,53A6.64,6.64,0,0,1,47.6,56a4.89,4.89,0,0,1,0,4.18,6.93,6.93,0,0,1-1.74,2.52,9,9,0,0,1-2.4,1.72,14,14,0,0,1-3,1,26.49,26.49,0,0,1-3.25.53,20.6,20.6,0,0,1-3.57.16.23.23,0,0,1-.13-.35.23.23,0,0,1,.14-.13c.77-.12,1.73-.28,2.87-.49a22.61,22.61,0,0,0,2.71-.76,12.22,12.22,0,0,0,2.51-1.11,10.26,10.26,0,0,0,2-1.61,7.55,7.55,0,0,0,1.49-2.27,6.19,6.19,0,0,0,.45-3.53A2.87,2.87,0,0,0,44,53.53a2.67,2.67,0,0,0-2-.05,4.2,4.2,0,0,0-1.85,1.26,1.78,1.78,0,0,1,.69.12A1.91,1.91,0,0,1,41.86,56a2.13,2.13,0,0,1,0,1.59,2.36,2.36,0,0,1-1.13,1.22,1.93,1.93,0,0,1-1.56,0,2.32,2.32,0,0,1-1.23-1.2,2.18,2.18,0,0,1,0-1.7,5.08,5.08,0,0,1,2.65-2.76A4.31,4.31,0,0,1,44.17,53",
    transform: "translate(-8.25 -4.88)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "rect3009",
    className: "cls-14",
    x: 7.54,
    y: 70.72,
    width: 78.62,
    height: 37.33
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M40.11,94.71h29",
    transform: "translate(-8.25 -4.88)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetagrab);
export default __webpack_public_path__ + "static/media/metagrab.91c6b48a20b9e41175a19f193b3ca201.svg";
export { ForwardRef as ReactComponent };